import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { formLabelStyling } from 'components/forms/new/formStyles';
import { FORM_FIELD_PATHS } from '../../constants';
import { stackSpacing, stackStyling } from 'components/forms/new/formStyles';

const SelectiveSyncPolicy = ({ darkMode, errors }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useCompanyForm();

    const syncPolicyOptions = [
        { id: 0, name: 'Disabled' },
        { id: 1, name: 'Enabled' },
        { id: 2, name: 'Required' },
    ];

    const handleSelectChange = (item) => {
        const selectedId = item?.id;
        updateFormData(FORM_FIELD_PATHS.SELECTIVE_SYNC_POLICY, selectedId);
    };

    const hasError = !!errors?.selectiveSyncPolicy;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Selective Sync Policy
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={DropDown}
                        id={FORM_FIELD_PATHS.SELECTIVE_SYNC_POLICY}
                        name={FORM_FIELD_PATHS.SELECTIVE_SYNC_POLICY}
                        data={syncPolicyOptions}
                        shownValue="name"
                        currentId={formData?.selectiveSyncPolicy}
                        selectedId="id"
                        placeholder="Select sync policy"
                        handleSelectChange={handleSelectChange}
                        width="100%"
                        isLoading={false}
                        darkMode={darkMode}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Configure how users are synchronized with Office 365"
                        ariaLabel="selective-sync-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default SelectiveSyncPolicy;
